import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  root: {
    position: "relative"
  },
  textfield: {
    margin: 0,
    "& label.MuiFormLabel-root": {
      color: theme.palette.secondary.dark,
      fontSize: 16
    },
    "& .MuiOutlinedInput-root": {
      fontSize: 14,
      "& fieldset": {
        borderColor: theme.palette.secondary.dark
      },
      "&:hover fieldset": {
        borderColor: theme.palette.secondary.dark
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.secondary.dark
      }
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      background: theme.palette.common.white,
      padding: "0 6px",
      transform: `translate(6px, -7px) scale(1)`
    }
  },
  counter: {
    fontSize: 10,
    position: "absolute",
    color: theme.palette.text.hint,
    textAlign: "center",
    minWidth: 58,
    width: 58,
    maxHeight: 14,
    height: 14,
    backgroundColor: theme.palette.common.white,
    right: 6,
    bottom: -7
  },
  controls: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 8
  },
  controlsCancel: {},
  controlsSave: {
    color: theme.palette.secondary.dark
  }
}));
